import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'

export function SEO({ currentSlug }) {
  const [siteInfo, setSiteInfo] = useState({
    name: 'Dara Brexendorf',
    description: 'Autorin und mediale Künstlerin'
  })

  useEffect(() => {
    // Fetch site information from WordPress REST API
    fetch('/wp-json')
      .then(res => res.json())
      .then(data => {
        setSiteInfo({
          name: data.name,
          description: data.description
        })
      })
      .catch(error => {
        console.error('Error fetching site info:', error)
      })
  }, [])

  // Define SEO configurations for different routes
  const seoConfig = {
    'front-page': {
      title: `Home | ${siteInfo.name}`,
      description: siteInfo.description
    },
    'publikationen': {
      title: `Publikationen | ${siteInfo.name}`,
      description: 'Publikationen und Werke'
    },
    'vita': {
      title: `Vita | ${siteInfo.name}`,
      description: 'Lebenslauf und Karriere'
    },
    'workshops': {
      title: `Workshops | ${siteInfo.name}`,
      description: 'Workshops und Veranstaltungen'
    },
    'kontakt': {
      title: `Kontakt | ${siteInfo.name}`,
      description: 'Kontaktinformationen und Anfragen'
    },
    'aktuelles': {
      title: `Aktuelles | ${siteInfo.name}`,
      description: 'Aktuelle Neuigkeiten und Veranstaltungen'
    },
    'text-im-raum': {
      title: `Text im Raum | ${siteInfo.name}`,
      description: 'Künstlerische Texte und Rauminterventionen'
    }
  }  // Fallback to default if no specific config exists
  const pageConfig = seoConfig[currentSlug] || {
    title: siteInfo.name,
    description: siteInfo.description
  }

  return (
    <Helmet>
      <title>{pageConfig.title}</title>
      <meta name="description" content={pageConfig.description} />
      <meta property="og:title" content={pageConfig.title} />
      <meta property="og:description" content={pageConfig.description} />
    </Helmet>
  )
}